// extracted by mini-css-extract-plugin
export default {"header":"Styles_header__T4eKI"};